import { SnakeIcon } from './SnakeIcon';

/**
 * author: Colton Wiscombe
 * id C525609F-8CAF-40A8-A3FC-724F6C699E0A
 * name snake
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/snake.svg
 * tags
 * - Animal 
 */
export const ReptileIcon = SnakeIcon;
export default ReptileIcon